import * as API from '../data/report_module_api';
import {signOutAction} from "./auth_actions";


export const GET_MODULE_LIST = "get_available_report_modules";

export function createTemplateModule(formData,successCallBack) {
    return async (dispatch) => {
        const response = await API.createModuleForReportTemplate(formData);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            successCallBack(response);
        }
    };
}

export function getModulesList() {
    return async (dispatch) => {
        const response = await API.getModulesList();
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({
                type: GET_MODULE_LIST,
                payload: response
            });
        }
    };
}

export function updateModule(formData,successCallBack) {
    return async (dispatch) => {
        const response = await API.updateModule(formData);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            if(response.success){
                dispatch(getModulesList());
            }
            successCallBack(response);
        }
    };
}

export function deleteModule(id,successCallBack) {
    return async (dispatch) => {
        const response = await API.deleteModule(id);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            if(response.data.success){
                dispatch(getModulesList());
            }
            successCallBack(response.data);
        }
    };
}


// WEBPACK FOOTER //
// ./src/actions/report_module_action.js